module.exports = __webpack_public_path__ + "media/Mobile_IN.e3b53e0b.mp4";